import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  title: '',
  url: '',
  description: '',
  instructions: '',
  deviceOrientation: '',
  imageLoader: {},
  soundsLoader: {},
  libLoader: {},
  deviceOrientationSizes: {
    landscape: {
      height: 720,
      width: 1280,
    },
    portrait: {
      height: 1280,
      width: 720,
    },
  },
  phaserUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/phaser/3.80.1/phaser.min.js',
  phaserVersion: '3.80.1',
}

const gameConfigSlice = createSlice({
  name: 'gameConfig',
  initialState,
  reducers: {
    updateGameConfig: (state, action) => {
      return { ...state, ...action.payload }
    },
    updateDescription: (state, action) => {
      state.description = action.payload
    },
    updateDeviceOrientation: (state, action) => {
      state.deviceOrientation = action.payload
    },
    updateImageLoader: (
      state,
      action: PayloadAction<Record<string, string>>
    ) => {
      state.imageLoader = { ...state.imageLoader, ...action.payload }
    },
    updateLibLoader: (
    state,
    action: PayloadAction<Record<string, string>>
    ) => {
    state.libLoader = { ...state.libLoader, ...action.payload }
      },
    updateInstructions: (state, action) => {
      state.instructions = action.payload
    },
    updatePhaserUrl: (state, action) => {
      state.phaserUrl = action.payload
    },
    updatePhaserVersion: (state, action) => {
      state.phaserVersion = action.payload
    },
    updateSoundsLoader: (
      state,
      action: PayloadAction<Record<string, string>>
    ) => {
      state.soundsLoader = { ...state.soundsLoader, ...action.payload }
    },

    updateTitle: (state, action) => {
      state.title = action.payload
    },
    clearGameConfig: () => {
      return { ...initialState }
    },
    deleteImageAsset: (state, action) => {
      const key = action.payload
      const { [key]: _, ...remainingImages } = state.imageLoader
      state.imageLoader = remainingImages
    },
    deleteSoundAsset: (state, action: PayloadAction<string>) => {
      const key = action.payload
      const { [key]: deleted, ...remainingSounds } = state.soundsLoader
      state.soundsLoader = remainingSounds
    },
    deleteLibAsset: (state, action: PayloadAction<string>) => {
    const key = action.payload
    const { [key]: deleted, ...remainingLibs } = state.libLoader
    state.libLoader = remainingLibs
    },
  },
})

export const {
  updateGameConfig,
  updateDescription,
  updateDeviceOrientation,
  updateImageLoader,
  updateInstructions,
  updatePhaserUrl,
  updatePhaserVersion,
  updateSoundsLoader,
  updateLibLoader,
  updateTitle,
  clearGameConfig,
  deleteImageAsset,
  deleteSoundAsset,
  deleteLibAsset,
} = gameConfigSlice.actions

export default gameConfigSlice.reducer
